var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hl_settings--body"},[(_vm.$route.name=='marketplace-apps-review')?_c('AppReviewComponent',{attrs:{"id":"marketplace-review-table-embed"}}):(_vm.$route.name=='marketplace-app-new')?_c('AppReviewComponent',{attrs:{"id":"marketplace-review-app-embed"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }